// extracted by mini-css-extract-plugin
module.exports = {"global-primary":"#2980b9"};